import React from 'react';
import { ChecklistItemContainer, ChecklistItemName, ChecklistTick } from './styled';

const ChecklistItem = ({ data, onClick, selectedItems }) => (
  <ChecklistItemContainer selected={selectedItems.includes(data.value)} onClick={() => onClick(data.value)}>
    <ChecklistTick selected={selectedItems.includes(data.value)} />
    <ChecklistItemName>{data.value}</ChecklistItemName>
  </ChecklistItemContainer>
    );

export default ChecklistItem;
